import { ReactNode } from 'react'
import { Licenses } from '../scenarios/data';
import { WebBrick } from './WebBrick'
import DownloadWLSLicenseFile from '../../pages/DownloadWLSLicenseFile'
import { createDescriptor, PageDescriptor } from '../../pages/types'

export class WLSBrick extends WebBrick {    
    private wlsLicense: string

    constructor(license: 'wlssu'|'wlsuu'|'wlscs') {
        super() 
        this.wlsLicense = license;       
    }

    get license() {
        return null
    }
    
    get title(): string {
        return 'Web License Service'
    }
    *getPages(): Generator<PageDescriptor> {
        yield createDescriptor(DownloadWLSLicenseFile, {})
    }

    describe(): ReactNode {
        return <p>The <b>Web License Service</b> is hosted by Gurobi and contains your <b>{Licenses[this.wlsLicense].name} license</b>.
        It keeps track of your (concurrent) Gurobi usage. You can view usage details and manage API keys online.</p>;
    }

    public key(): string { 
        return 'wls'
    }
}
